import {User} from 'interfaces';
import {track as trackOptimizely} from 'marketplace/utilities/optimizely';
import {setIsSubscribed} from 'marketplace/utilities/subscription-cookie';
import {trackTealium} from "utilities/analytics";
import {ContactTrackingData} from '../../types';

export interface ContactApiOptions {
  authenticityToken: string;
  formValues: {
    message: string;
    finances: boolean;
    subscribe: boolean;
    introduction: string;
  };
  user?: User;
  contactTracking: ContactTrackingData;
}

const CONTACT_URI = 'contact';

const headers = {
  'Content-Type': 'application/json',
};

const ANALYTICS = {
  gaContactAction: 'success',
  gaContactCategory: 'contact_seller',
  gaSubscribeLabel: 'email',
  gaSubscribeAction: 'contact_form',
  gaSubscribeCategory: 'exchange_subscribe',
  optimizelyEvent: '',
};

export async function contactSeller({
  authenticityToken,
  formValues,
  contactTracking,
}: ContactApiOptions) {
  const body = JSON.stringify({
    /* eslint-disable-next-line babel/camelcase */
    authenticity_token: authenticityToken,
    contact: formValues,
  });

  try {
    const response = await fetch(`${location.pathname}/${CONTACT_URI}`, {
      body,
      headers,
      method: 'POST',
      credentials: 'same-origin',
    });

    if (response.ok) {
      contactSuccessTracking(formValues.subscribe, contactTracking);
      return true;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
}

export async function contactSuccessTracking(subscribe: boolean, contactTracking: ContactTrackingData) {
  const {optimizelyEvent, gaContactCategory, gaContactAction} = ANALYTICS;
  await trackTealium(gaContactCategory, gaContactAction, contactTracking.gaLabel);
  trackOptimizely(optimizelyEvent);

  if (subscribe) {
    const {gaSubscribeAction, gaSubscribeCategory, gaSubscribeLabel} = ANALYTICS;
    await trackTealium(gaSubscribeCategory, gaSubscribeAction, gaSubscribeLabel);
    setIsSubscribed(true);
  }

  return true;
}
